import Routes from '../routes';
import rootRoutes from 'routing/router';

const RouterOutlet = () => {
	return <Routes routes={rootRoutes}/>;
};

export default RouterOutlet;
